import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Array Filter Polyfill",
  url: "array-filter-polyfill",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {number[]} arr
* @param {function()} cb
* @return {number[]}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function filter(arr, cb) {
  // your code goes here        
};
`,
};

export default info;
